import React, { useEffect } from 'react'
import Layout from './Layout'
import UnitTile from './UnitTile'
import AddUnitButton from './AddUnitButton'
import { useDispatch, useSelector } from 'react-redux'
import { FETCH_UNITS } from '../redux/unitsReducer'
import { RootReducer } from '../redux/rootReducer'

const UnitsScreen = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(FETCH_UNITS())
  }, [dispatch])

  const units = useSelector((state: RootReducer) => state.unitsReducer.units)

  return (
    <Layout>
      <AddUnitButton />
      <div className="h-4" />
      <div className="grid grid-cols-3 gap-4">
        {units.map((unit) => (
          <UnitTile
            key={unit.id}
            imageUrl={unit.image || ''}
            unitName={unit.name}
            unitDescription={unit.description}
            id={unit.id.toString()}
          />
        ))}
      </div>
    </Layout>
  )
}

export default UnitsScreen
